class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]')?.addEventListener('click', this.close.bind(this));
    
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    let target = event.target != "details" ? event.target.closest('details') : event.target;
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    if (!target.querySelector('summary').classList.contains('header__icon--search')){
      document.body.classList.add('overflow-hidden');
    }  

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    
    // if (event?.target?.querySelector('summary')?.classList.contains('header__icon--search')){
    //   document.body.classList.remove('overflow-hidden');
    // }
    if(this.isOpen())document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

// class DetailsModal extends HTMLElement {
//   constructor() {
//     super();
//     this.detailsContainer = this.querySelector('details');
//     this.summaryToggle = this.querySelector('summary');

//     this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close(event));
//     this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
//     this.querySelector('button[type="button"]')?.addEventListener('click', this.close.bind(this));

//     this.summaryToggle.setAttribute('role', 'button');
//   }

//   isOpen() {
//     return this.detailsContainer.hasAttribute('open');
//   }

//   onSummaryClick(event) {
//     event.preventDefault();
//     event.target.closest('details').hasAttribute('open') ? this.close(event) : this.open(event);
//   }

//   onBodyClick(event) {
//     if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(event, false);
//   }

//   open(event) {
//     let target = event.target != "details" ? event.target.closest('details') : event.target;
//     if(target.querySelector('summary').classList.contains('header__icon--search')){
//       const childElement = target.querySelector('.modal__toggle-open');
//       if (childElement) {
//           childElement.style.display = 'none';
//       }
//     }
    
//     this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
//     event.target.closest('details').setAttribute('open', true);
//     document.body.addEventListener('click', this.onBodyClickEvent);
    
//     if (!target.querySelector('summary').classList.contains('header__icon--search')){
//        document.body.classList.add('overflow-hidden');
//     }

//     trapFocus(
//       this.detailsContainer.querySelector('[tabindex="-1"]'),
//       this.detailsContainer.querySelector('input:not([type="hidden"])')
//     );
//   }

//   close(event, focusToggle = true) {
   
//     removeTrapFocus(focusToggle ? this.summaryToggle : null);
//     this.detailsContainer.removeAttribute('open');
        
//     const childElement = this.detailsContainer.querySelector('.modal__toggle-open');
//     if (childElement) {
//         childElement.style.display = 'block';
//     }
    
//     document.body.removeEventListener('click', this.onBodyClickEvent);
  
//     if (event?.target?.querySelector('summary')?.classList.contains('header__icon--search')){
//       document.body.classList.remove('overflow-hidden');
//     }
//   }
// }

// customElements.define('details-modal', DetailsModal);
